import { Button, Camera, Text } from '@myinterview/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DEVICE } from '../utils/device.utils';

interface IProps {
  onRetry: () => void;
}

export const PermissionSteps:React.FC<IProps> = ({ onRetry }) => {
  const { t } = useTranslation();
  const permissionsSteps = () => {
    const { PLATFORM, BROWSER } = DEVICE;
    const tips: [] = t(
      [`recorder.permissions.PERMISSION_STEPS.${PLATFORM}.${BROWSER}`,
        `recorder.permissions.PERMISSION_STEPS.${PLATFORM}.CHROME`],
      { returnObjects: true },
    );
    return tips.map((step: string) => <li className="myinterview-widget-permissions__step" key={step} dangerouslySetInnerHTML={{ __html: step }} />);
  };
  return (
    <div className="myinterview-widget-permissions__wrapper myinterview-widget--rtl-support">
      <div className="myinterview-widget-permissions__icon-wrapper">
        <Camera />
      </div>
      <Text
        className="myinterview-widget-permissions__title"
        size="L-Bold"
      >
        {t('recorder.permissions.title')}
      </Text>
      <Text
        className="myinterview-widget-permissions__sub-title"
        size="S-Regular"
        color="neutral-60"
      >
        {t('recorder.permissions.subtitle')}
      </Text>
      <ul className="myinterview-widget-permissions__steps-wrapper">
        {permissionsSteps()}
      </ul>
      <Button
        className="myinterview-widget-permissions__button"
        onClick={onRetry}
      >
        {t('buttons.btn_try_again')}
      </Button>
    </div>
  );
};
